import Icon, { DownloadOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { message, Button, Modal, Upload } from 'antd';
import React, { useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { waBuyerUpload } from 'services/api/waBuyers';
import { ReactComponent as excelSvg } from 'views/Setting/assets/excel.svg';

const Flex = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 16px;
  .upload {
    svg {
      width: 25px;
      height: 25px;
    }
    .desc {
      margin-top: 8px;
      color: var(--fett-app-primary-color);
    }
    .limit {
      margin-top: 6px;
      font-size: 12px;
      color: var(--fett-text-tertiary);
    }
  }
  .hide {
    .ant-upload.ant-upload-drag {
      display: none;
    }
  }
`;

const ModalUpload = ({
  visModalUpload,
  setVisModalUpload,
  setRefreshAgain,
}: {
  visModalUpload: boolean;
  setVisModalUpload: React.Dispatch<React.SetStateAction<boolean>>;
  setRefreshAgain: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { t } = useTranslate();

  const [fileList, setFileList] = useState<File[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <Modal
      title={t('WhatsappBuyers.批量添加WA买家')}
      visible={visModalUpload}
      width={568}
      onCancel={() => {
        setVisModalUpload(false);
        setFileList([]);
      }}
      maskClosable={false}
      confirmLoading={loading}
      okButtonProps={{ disabled: !fileList.length }}
      destroyOnClose
      okText={t('WhatsappBuyers.确定添加')}
      onOk={() => {
        const formData = new FormData();
        formData.append('file', fileList[0]);
        setLoading(true);

        waBuyerUpload(formData)
          .then(() => {
            setVisModalUpload(false);
            message.success(t('translation.设置成功'));
            setFileList([]);
            setTimeout(() => {
              setRefreshAgain((v) => v + 1);
            }, 1000);
          })
          .catch((e) => {
            setFileList([]);
            message.error(t('translation.操作失败，请稍后再试'));
          })
          .finally(() => {
            setLoading(false);
          });
      }}
    >
      <Flex>
        <span>{t('ViewShops.上传文件')}:</span>
        <div style={{ flex: 1 }}>
          <div style={{ textAlign: 'right' }}>
            <Button
              type="link"
              icon={<DownloadOutlined />}
              style={{ color: 'var(--fett-app-primary-color)' }}
              href="https://clients.zhisuitech.com/fett-public/WA%E4%B9%B0%E5%AE%B6%E6%A8%A1%E6%9D%BF.xlsx"
              target="_blank"
            >
              {t('WhatsappBuyers.下载WA店铺模版')}
            </Button>
          </div>
          <div className={`upload ${!fileList.length ? ' ' : 'hide'}`}>
            <Upload.Dragger
              accept=".xlsx,.xls"
              maxCount={1}
              listType="picture"
              beforeUpload={(file) => {
                setFileList([file]);
                return false;
              }}
              onRemove={() => setFileList([])}
              iconRender={() => <Icon component={excelSvg} />}
            >
              <Icon component={excelSvg} />
              <div className="desc">{t('ViewShops.点击或者将文件拖拽到此区域上传')}</div>
              <div className="limit">{t('ViewShops.限1个文件，文件拓展名为.xlsx .xls')}</div>
            </Upload.Dragger>
          </div>
        </div>
      </Flex>
    </Modal>
  );
};

export default ModalUpload;
